<template>
  <div>
    <!-- 企业提现 -->
    <el-dialog class="fapiaoInfo" width="1000px" top="5vh" show-close :visible.sync="visible">
      <div class="titless">
        <i></i>
        <span>确认提现</span>
      </div>
      <el-tabs v-model="tabId">
        <el-tab-pane label="线上提交资料" name="online"></el-tab-pane>
        <el-tab-pane label="线下邮寄资料" name="offline"></el-tab-pane>
      </el-tabs>
      <template v-if="level == 1">
        <div class="titless child" style="margin-bottom: 15px" v-if="tabId == 'online'">
          <span>申请提现需提供发票及结算函/结算明细盖章文件</span>
        </div>
        <div class="titless child" style="margin-bottom: 15px" v-if="tabId == 'offline'">
          <span>申请提现需提供结算资料邮寄信息</span>
          <br />
          <span>注:结算函及结算明细需加盖公章或财务章(如为纸质发票需邮寄原件我司)</span>
        </div>
      </template>

      <template v-if="tabId == 'offline'">
        <el-input v-model="bankData.bankUserNameBak" class="df-inp" :disabled="true">
          <template slot="prepend">户名</template>
        </el-input>
        <el-input v-model="bankData.bankType" class="df-inp" :disabled="true">
          <template slot="prepend">开户行</template>
        </el-input>
        <el-input v-model="bankData.bankAccountBak" class="df-inp" :disabled="true">
          <template slot="prepend">银行账号</template>
        </el-input>
        <el-input v-model="bankData.bankAddress" class="df-inp" :disabled="true">
          <template slot="prepend">开户行地址</template>
        </el-input>
        <div v-if="level == 1">
          <div class="titless child3">发票邮寄信息</div>
          <el-input placeholder="请输入快递信息，例：顺丰速运" v-model="formData.expressCompany" class="df-inp">
            <template slot="prepend">快递公司</template>
          </el-input>
          <el-input placeholder="请输入快递运单号，方便我司及时查询" v-model="formData.courierNumber" class="df-inp">
            <template slot="prepend">运单号</template>
          </el-input>
        </div>
      </template>
      <div class="seal-input" v-if="level == 1">
        <div class="seal-title">发票PDF文件</div>
        <el-upload
          class="seal-uploader"
          :multiple="true"
          accept=".pdf"
          :before-upload="beforeUpload"
          :action="$config.api_root + '/resmgr/upload'"
          :show-file-list="false"
          :on-success="(res, file) => sealUploadSuccess(res, file, 'invoice')"
        >
          <div class="img-list">
            <div class="img-item" v-for="(item, i) in invoiceList" :key="i" @click.stop>
              <a :href="item.url" target="_blank"><img src="@static/images/product/cc_pdf.png"/></a>
              <i class="el-icon-delete" @click="invoiceList.splice(i, 1)"></i>
            </div>
            <div class="seal-upload-btn">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-upload>
        <div class="seal-title">结算函盖章版(PDF文件)</div>
        <el-upload
          class="seal-uploader"
          :multiple="true"
          accept=".pdf"
          :before-upload="beforeUpload"
          :action="$config.api_root + '/resmgr/upload'"
          :show-file-list="false"
          :on-success="(res, file) => sealUploadSuccess(res, file, 'relatedImageUrls')"
        >
          <div class="img-list">
            <div class="img-item" v-for="(item, i) in relatedImageUrls" :key="i" @click.stop>
              <a :href="item.url" target="_blank"><img src="@static/images/product/cc_pdf.png"/></a>
              <i class="el-icon-delete" @click="relatedImageUrls.splice(i, 1)"></i>
            </div>
            <div class="seal-upload-btn">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-upload>
        <div class="seal-title">结算明细盖章版(PDF文件)</div>
        <el-upload
          class="seal-uploader"
          :multiple="true"
          accept=".pdf"
          :before-upload="beforeUpload"
          :action="$config.api_root + '/resmgr/upload'"
          :show-file-list="false"
          :on-success="(res, file) => sealUploadSuccess(res, file, 'settlementDetailUrls')"
        >
          <div class="img-list">
            <div class="img-item" v-for="(item, i) in settlementDetailUrls" :key="i" @click.stop>
              <a :href="item.url" target="_blank"><img src="@static/images/product/cc_pdf.png"/></a>
              <i class="el-icon-delete" @click="settlementDetailUrls.splice(i, 1)"></i>
            </div>
            <div class="seal-upload-btn">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-upload>
      </div>
      <div class="rules" v-if="level == 1">
        <p>注意事项</p>
        <p>1、开具发票：机构用户请根据申请金额开具服务发票；</p>
        <p>2、发票填写：请根据开票信息，确保发票抬头、发票项目、发票金额准确无误，否则我司将不予付款；</p>
        <p>3、我司将在收到发票及结算资料审核无误后进行结算打款(线下邮寄资料以收到为准进行审核)。<a @click="$emit('openInvoiceDetail')">查看开票信息</a></p>
        <p>4、如您选择提供电子版结算材料，需签署<a @click="openAgreement()">《关于对账资料交付确认函》</a>并邮寄原件至我司</p>
      </div>

      <div class="flagButton">
        <el-button type="warning" center @click="submit()" :loading="loading">确定</el-button>
        <p class="df-p11">如有疑问，请联系客服热线：400-8788-100</p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  mixins: [],
  components: {},
  data: () => ({
    visible: false,
    loading: false,
    fileLoadingFn: null,
    level: '',
    tabId: 'online',
    mechanUserType: '',
    relatedImageUrls: [],
    settlementDetailUrls: [],
    invoiceList: [], // 发票
    bankData: {},
    formData: {}
  }),
  created() {
    const user = this.$tools.getLocal('userinfo');
    this.level = user.level;
    this.mechanUserType = user.mechanUserType; //1机构2，3个人
  },
  methods: {
    open(data) {
      this.relatedImageUrls = [];
      this.settlementDetailUrls = [];
      this.invoiceList = [];
      this.formData = {
        relatedImageUrls: '',
        settlementDetailUrls: '',
        expressCompany: '',
        courierNumber: '',
        id: data.id,
        cashPlatType: 1 // 1:pc 2微信  3:app
      };
      this.getBankInfo();
      this.visible = true;
    },
    getBankInfo() {
      this.$http({
        url: '/master/means/getBankInfo',
        type: 'put',
        params: {}
      }).then(res => {
        const data = res.data;
        data.toucherNameBak = '*' + data.toucherName.substring(1);
        data.toucherMobileBak = data.toucherMobile.substring(0, 3) + '****' + data.toucherMobile.substring(7);
        if (data.bankAccount && data.bankAccount.length > 8) {
          //银行卡
          data.bankAccountBak =
            data.bankAccount.substring(0, 4) + '*'.repeat(data.bankAccount.length - 8) + data.bankAccount.substring(data.bankAccount.length - 4);
        } else {
          data.bankAccountBak = data.bankAccount;
        }
        if (data.bankUserName) {
          //户主姓名
          data.bankUserNameBak = '*' + data.bankUserName.substring(1);
        } else {
          data.bankUserNameBak = data.bankUserName;
        }
        this.bankData = data;
        if (this.$refs['bankForm']) {
          this.$refs['bankForm'].clearValidate();
        }
      });
    },
    //提交
    submit() {
      if (this.mechanUserType == 1) {
        if (!this.bankData.bankUserName || !this.bankData.bankAccount || !this.bankData.bankAddress || !this.bankData.bankType) {
          this.$message.error('请完善银行账户信息');
          return;
        }

        if (this.level == 1) {
          if (this.tabId == 'offline' && !this.formData.expressCompany) {
            //发票地址
            this.$message.error('请填写快递信息');
            return;
          } else if (this.tabId == 'offline' && !this.formData.courierNumber) {
            this.$message.error('请输入快递运单号');
            return;
          } else if (this.invoiceList.length == 0) {
            this.$message.error('请上传发票PDF文件');
            return;
          } else if (this.relatedImageUrls.length == 0) {
            this.$message.error('请上传结算函盖章PDF文件');
            return;
          } else if (this.settlementDetailUrls.length == 0) {
            this.$message.error('请上传结算明细PDF文件');
            return;
          }
        }
      }
      const data = JSON.parse(JSON.stringify(this.formData));
      data.invoiceUrls = JSON.stringify(this.invoiceList);
      data.relatedImageUrls = JSON.stringify(this.relatedImageUrls);
      data.settlementDetailUrls = JSON.stringify(this.settlementDetailUrls);
      data.cashPlatType = 1; // 1:pc 2微信  3:app
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$http({
        url: '/master/means/applyCashPostalMerge',
        type: 'put',
        params: data
      })
        .then(data => {
          this.visible = false;
          this.$emit('reload');
        })
        .finally(() => {
          window.setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    //盖章图片 上传成功回调
    sealUploadSuccess(res, file, fileType) {
      this.fileLoadingFn && this.fileLoadingFn.close();
      if (file.response.httpCode == 200) {
        const data = file.response.data[0];
        const img = {
          name: data.name,
          url: data.wwwurl
        };
        if (fileType == 'invoice') {
          this.invoiceList.push(img);
        } else  {
          this[fileType].push(img);
        }
      }
    },
    // 上传之前格式校验
    beforeUpload(file) {
      const isPDF = file.type === 'application/pdf';
      if (!isPDF) {
        this.$message.error('只能上传PDF文件');
        return false;
      }
      this.fileLoadingFn = this.$notice.loading('上传中...');
      return true;
    },
    // 打开协议
    openAgreement() {
      window.open('./financeAgreement.html');
    }
  }
};
</script>
<style lang="scss" scoped>
.fapiaoInfo /deep/ {
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 20px 30px;
  }

  .titless {
    margin-bottom: 10px;
    i {
      display: inline-block;
      width: 4px;
      height: 16px;
      background: #ff9700;
      vertical-align: middle;
      margin-right: 10px;
    }

    span {
      font-size: 16px;
      vertical-align: middle;
    }

    &.child {
      margin-top: 10px;
    }

    &.child2 {
      margin-top: 20px;
      margin-bottom: 15px;
    }

    &.child3 {
      margin-bottom: 15px;
    }

    a {
      color: #009cfe;
    }
  }

  .df-inp {
    width: 400px;
    margin-right: 40px;
    margin-bottom: 20px;
    vertical-align: top;
  }

  .el-input.is-disabled .el-input__inner {
    background-color: #fff;
  }

  .el-input-group__prepend {
    width: 110px;
  }

  .df-select {
    .el-input__prefix {
      background-color: #f5f7fa;
      color: #909399;
      vertical-align: middle;
      display: table-cell;
      position: relative;
      border: 1px solid #dcdfe6;
      position: absolute;
      left: 0;
      top: 0;
      width: 110px;
      height: 40px;
      line-height: 40px;
      box-sizing: border-box;
      padding: 0 15px;
    }

    .el-input__inner {
      padding-left: 125px;
    }
  }

  .seal-input {
    .seal-title {
      margin-top: 10px;
      margin-bottom: 10px;
      &::before {
        content: '*';
        color: red;
        margin-right: 3px;
      }
    }

    .img-list {
      text-align: left;

      .img-item {
        display: inline-block;
        position: relative;
        margin-right: 10px;
        margin-bottom: 10px;

        img {
          width: 120px;
          height: 120px;
        }

        i {
          display: block;
          position: absolute;
          right: 0;
          top: 0;
          background-color: rgba(0, 0, 0, 0.5);
          text-align: right;
          font-size: 20px;
          color: #fff;
        }

        &:hover {
          i {
            display: block;
          }
        }
      }
    }

    .seal-uploader {
      .seal-upload-btn {
        width: 120px;
        height: 120px;
        display: inline-flex;
        vertical-align: top;
        justify-content: center;
        align-items: center;
        border: 1px solid #ddd;
        font-size: 50px;

        .el-icon-plus {
          color: #ddd;
        }
      }
    }
  }

  .rules {
    font-size: 14px;
    line-height: 24px;
    margin-top: 20px;

    a {
      color: #009cfe;
    }
  }

  .flagButton {
    text-align: center;
    margin-top: 40px;

    .el-button {
      padding: 15px 80px;
    }

    p {
      margin-top: 10px;
    }
  }
}
</style>
